var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "locations-page",
      class: {
        "locations-page--geo-loading": _vm.loading
      }
    },
    [
      _c("div", { staticClass: "divider" }, [
        _c("div", { staticClass: "divider__left" }, [
          _c(
            "div",
            {
              staticClass: "location-box insicht insicht--fade-up insicht--fast"
            },
            [
              _c("div", { staticClass: "location-box__wrapper" }, [
                _c("h2", {
                  staticClass: "location-box__title",
                  domProps: { innerHTML: _vm._s(_vm.$t("locations.title")) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "location-box__content" }, [
                  _c(
                    "div",
                    { staticClass: "location-box__links" },
                    [
                      _vm.geolocationAvailable
                        ? _c("Button", {
                            staticClass: "location-box__link",
                            attrs: {
                              icon: "geo-location",
                              text: _vm.$t("locations.geoButton"),
                              type: "button",
                              level: "tertiary",
                              arrow: ""
                            },
                            on: { click: _vm.geolocationRequest }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider__right divider__right--overlap" }, [
          _c(
            "div",
            {
              staticClass: "location-grid",
              class: {
                "location-grid--geo-loading": _vm.loading
              }
            },
            _vm._l(_vm.processedLocations, function(location) {
              return _c(
                "div",
                {
                  key: location.id,
                  staticClass: "location-grid__item insicht insicht--fade-in"
                },
                [
                  _c("div", { staticClass: "location-grid__item-wrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "location-grid__item-image",
                        attrs: { href: location.url }
                      },
                      [
                        _c("img", {
                          staticClass: "location-grid__item-image-element",
                          attrs: {
                            srcset: location.image.srcset,
                            src: location.image.src,
                            alt: location.title,
                            "data-object-fit": "",
                            loading: "lazy"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("a", {
                      staticClass: "location-grid__item-title",
                      attrs: { href: location.url },
                      domProps: { innerHTML: _vm._s(location.title) }
                    }),
                    _vm._v(" "),
                    _vm.showDistance
                      ? _c("span", {
                          staticClass: "location-grid__item-distance",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatDistance(location.distance)
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ul", { staticClass: "location-grid__item-icons" }, [
                      location.telephone
                        ? _c(
                            "li",
                            { staticClass: "location-grid__item-icon" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "location-grid__item-icon-link",
                                  attrs: {
                                    href: _vm.telUrl(location.telephone)
                                  }
                                },
                                [_c("SVGPhone")],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      location.googleMapsUrl
                        ? _c(
                            "li",
                            { staticClass: "location-grid__item-icon" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "location-grid__item-icon-link",
                                  attrs: {
                                    href: location.googleMapsUrl,
                                    target: "_blank"
                                  }
                                },
                                [_c("SVGLocation")],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "location-grid__item-links" },
                      [
                        _vm.showOrder(location)
                          ? _c("Button", {
                              staticClass: "location-grid__item-link",
                              attrs: {
                                text: _vm.$t("locations.orderButton"),
                                type: "button",
                                level: "tertiary",
                                arrow: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onOrder(location.code)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showReservation(location)
                          ? _c("Button", {
                              staticClass: "location-grid__item-link",
                              attrs: {
                                text: _vm.$t("locations.reserveButton"),
                                type: "button",
                                level: "tertiary",
                                arrow: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onReservation(location.code)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "location-grid__item-openings" },
                      [
                        location.specialOpeningHours
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "location-grid__item-openings-special"
                              },
                              _vm._l(location.specialOpeningHours, function(
                                opening,
                                index
                              ) {
                                return opening.message
                                  ? _c("div", {
                                      key: "special-opening-" + index,
                                      staticClass:
                                        "location-grid__item-openings-special-entry",
                                      domProps: {
                                        innerHTML: _vm._s(opening.message)
                                      }
                                    })
                                  : _vm._e()
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        location.openingHours.length
                          ? [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "location-grid__item-openings-table"
                                },
                                _vm._l(location.openingHours, function(
                                  opening,
                                  index
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: index + "-" + opening.day,
                                      staticClass:
                                        "location-grid__item-openings-table-row"
                                    },
                                    [
                                      _c("td", {
                                        staticClass:
                                          "location-grid__item-openings-table-cell",
                                        domProps: {
                                          innerHTML: _vm._s(opening.day)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("td", {
                                        staticClass:
                                          "location-grid__item-openings-table-cell",
                                        domProps: {
                                          innerHTML: _vm._s(opening.times)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "location-grid__item-openings-message",
                                domProps: {
                                  innerHTML: _vm._s(location.openTimesHtml)
                                }
                              })
                            ]
                          : _c("div", {
                              staticClass:
                                "location-grid__item-openings-message",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("locations.closedTitle")
                                )
                              }
                            })
                      ],
                      2
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }